import axios from 'axios';

import { ENV } from './env';

export const API_AXIOS = axios.create({
    baseURL: ENV.API_URL,
    headers: {
        Accept: 'application/ld+json',
        'Content-Type': 'application/ld+json',
    },
});

export const INCIDENCE_API_AXIOS = axios.create({
    baseURL: ENV.API_URL_INCIDENTS,
    headers: {
        Accept: 'application/ld+json',
        'X-AUTH-TOKEN': ENV.API_KEY_INCIDENTS,
    },
});
